import { httpClient } from '@/services/http/httpClient'

type UpdateCommentParams = {
  id: string
  content: string
}

export async function updateComment({
  id,
  content,
}: UpdateCommentParams): Promise<void> {
  await httpClient.put(`/ideas/idea-comments/${id}`, {
    message: content,
  })
}
